import React, { useState, useEffect, useContext, useRef } from "react";
import { Container, Row, Col, Tab, Nav, Spinner } from "react-bootstrap";
import "./SelectByCategories.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import Product_Card from "../../Common-Component/Product_Card/Product_Card";
import Popular_Product_Card from "../../Common-Component/Popular_Product_Card/Popular_Product_Card";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { Category, Products } from "../../../utils/apis/Product/Product";
import DoubleHeading from "../../Common-Component/DoubleHeading/DoubleHeading";
import Loader_lottie from "../../Animation/Loader_lottie/Loader_lottie";
import { ShimmerThumbnail } from "react-shimmer-effects";

library.add(fas);

const SelectByCategories = () => {
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [numToShow, setNumToShow] = useState(5);
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const sectionRef = useRef(null);

  const { IMG_URL, shimmerLoader, setShimmerLoader } = useContext(Context);

  const [category, setCategory] = useState([]);
  const [products, setProducts] = useState([]);

  const getCategory = async () => {
    try {
      setShimmerLoader(true);
      const res = await Category();
      if (res?.success) {
        await setCategory(res.data);
        await getProduct(res?.data[0]?.id);
      }
    } finally {
      setShimmerLoader(false);
    }
  };

  const getProduct = async (category_id) => {
    try {
      setShimmerLoader(true);
      const res = await Products(category_id);
      if (res?.success) {
        await setProducts(res?.data?.data);
        await setNumToShow(window.innerWidth < 575 ? 8 : 5);
        await setShowAll(false);
      }
    } finally {
      setShimmerLoader(false);
    }
  };

  useEffect(() => {
    getCategory();

    const handleResize = async () => {
      const mobile = window.innerWidth < 575;
      await setIsMobile(mobile);
      await setNumToShow(mobile ? 10 : 8);
      await setShowAll(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  return (
    <section className="select-categories" ref={sectionRef}>
      <Container fluid>
        <div className="mb-4">
          <DoubleHeading heading={"Select by Category"} />
        </div>

        <Tab.Container id="left-tabs-example" defaultActiveKey={"first"}>
          <div>
            <Swiper
              breakpoints={{
                0: { slidesPerView: 2, spaceBetween: 10 },
                420: { slidesPerView: 3, spaceBetween: 10 },
                486: { slidesPerView: 3, spaceBetween: 10 },
                576: { slidesPerView: 4, spaceBetween: 10 },
                768: { slidesPerView: 5, spaceBetween: 10 },
                992: { slidesPerView: 6, spaceBetween: 10 },
                1200: { slidesPerView: 8, spaceBetween: 10 },
              }}
              pagination={{ dynamicBullets: true, clickable: true }}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              modules={[Pagination, Autoplay, Navigation]}
              onSwiper={(swiper) => setSwiperInstance(swiper)}
              className="mySwiper pb-4">
              {category?.map((slide, index) => (
                <SwiperSlide key={index}>
                  <Nav.Item>
                    <Nav.Link
                      eventKey={index === 0 ? "first" : slide?.name}
                      onClick={() => getProduct(slide?.id)}>
                      <Popular_Product_Card
                        className="product-image"
                        content={slide?.name}
                        image={IMG_URL + slide?.image}
                        imgClassName="category-image"
                      />
                      <div className="triangle-right"></div>
                    </Nav.Link>
                  </Nav.Item>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {category?.map((slide, index) => (
            <Tab.Content key={index}>
              <Tab.Pane eventKey={index === 0 ? "first" : slide?.name}>
                <div className="desktop_view_product_category_slider">
                  {shimmerLoader ? (
                    <ShimmerThumbnail rounded />
                  ) : (
                    // <div className="loader-container text-center my-5">
                    //   <Loader_lottie />
                    //   <p className="mt-2">Loading products...</p>
                    // </div>
                    <Row>
                      {products.slice(0, numToShow).map((product, idx) => {
                        const price =
                          product?.product_multiple_mains?.[0]
                            ?.product_multiple_variants?.[0]?.mrp ||
                          product?.product_variants?.[0]?.mrp;

                        const cutprice =
                          product?.product_multiple_mains?.[0]
                            ?.product_multiple_variants?.[0]?.cutting_price ||
                          product?.product_variants?.[0]?.cutting_price;

                        return (
                          <Col
                            key={idx}
                            xxl={3}
                            xl={3}
                            lg={3}
                            md={4}
                            sm={4}
                            xs={6}
                            className="custom_class_product">
                            <Product_Card
                              image={IMG_URL + product?.image1}
                              text={product?.name}
                              product_id={product?.id}
                              subText={product?.short_description}
                              price={price}
                              cutprice={cutprice}
                              newest={product?.newest}
                              m_variant_id={
                                product?.product_multiple_mains?.[0]
                                  ?.product_multiple_variants?.[0]?.id
                              }
                              variant_id={product?.product_variants?.[0]?.id}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  )}
                </div>
              </Tab.Pane>
            </Tab.Content>
          ))}
        </Tab.Container>
        {/* )} */}

        {/* {products.length > numToShow && (
          <div className="view-all mb-5" onClick={toggleShowAll}>
            <p>
              {isMobile
                ? numToShow >= products.length
                  ? "View Less"
                  : "View All"
                : showAll
                ? "View Less"
                : "View All"}
            </p>
          </div>
        )} */}

        {products.length > numToShow && (
          <div
            className="view-all mt-4"
            onClick={() => navigate("/select-from-category/27")}>
            <p>View All</p>
          </div>
        )}
      </Container>
    </section>
  );
};

export default SelectByCategories;
